/**
 * 获取指定车型详细参数
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
// 接口地址  /api/v1/used_car/ticket/car_info/2578/images
Mock.mock(/used_car\/ticket\/car_info\/2578\/images/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'images': [{
      'image_url': '',
      'position': 1,
      'position_code': 'left_front',
      'position_name': '左前方'
    }, {
      'image_url': '',
      'position': 2,
      'position_code': 'left',
      'position_name': '左侧'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/7XBUspvke5bucUfJAo6kig.jpg',
      'position': 3,
      'position_code': 'front_chair',
      'position_name': '前排座椅'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/sdNd4Ly35MUC8mZCW5RkvZ.jpg',
      'position': 4,
      'position_code': 'dashboard',
      'position_name': '仪表盘'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/haPvHmkuqQt9ThsFdSkQ5H.jpg',
      'position': 5,
      'position_code': 'back_chair',
      'position_name': '后排座椅'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/BBT9anw7ikokvTY6V5656J.jpg',
      'position': 6,
      'position_code': 'central_control_board',
      'position_name': '中控板'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/x4PtEp8nwS8evkkfJ5YTNm.jpg',
      'position': 7,
      'position_code': 'end',
      'position_name': '车尾'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/ENGym7XuTDAHFssMtF4728.jpg',
      'position': 8,
      'position_code': 'trunk_bottom',
      'position_name': '后备箱底板'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/LriYsG8oK7GnSFCQmEDVaN.jpg',
      'position': 9,
      'position_code': 'right_end',
      'position_name': '右后方'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/FK3e9LcSNzDdhFtGBYzCJ7.jpg',
      'position': 10,
      'position_code': 'engine_compartment',
      'position_name': '发动机舱'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/B7bqkJsiGDiX9XWDTdfshk.jpg',
      'position': 11,
      'position_code': 'factory_nameplate',
      'position_name': '出厂铭牌'
    }, {
      'image_url': 'https://test-images-cdn.cheanjia.com/zhongsheng/qiye_image/bwXTvZwHqQeJkxFR24i93Q.jpg',
      'position': 12,
      'position_code': 'other_1',
      'position_name': '其他'
    }]
  }
})
